import { useMemo } from 'react';
import { adobeOpenClick, adobeErrorToast } from '@wix/bi-logger-media-data/v2';
import { MediaManagerSDKFile } from '../../media-manager-sdk';
import { bi } from '../../../services/loggers/bi';
import { extractCommonBiFieldsFromItems, getItemFormat } from '../../bi';
import { useFileType } from '../bi/useFileType';
import { useMMGRSettings } from '../../hoc/withMMGRSettings';
// import { getFileExtension } from '../../media-manager-sdk/items';

export enum AdobeOpenClickSource {
  ActionsPanel = 'actions_panel',
  ActionsMenu = 'actions_menu',
}

export const useAdobeExpressBI = () => {
  const {
    mmgrSettings: { publicMediaRoot },
  } = useMMGRSettings();
  const fileType = useFileType();

  return useMemo(
    () => ({
      trackAdobeOpenClick: (item: MediaManagerSDKFile, source: AdobeOpenClickSource) =>
        bi.logger().report(
          adobeOpenClick({
            ...extractCommonBiFieldsFromItems(item, { fileType }),
            source,
            fileFormat: getItemFormat(item),
            fileOrigin: 'adobe',
            mediaRoot: publicMediaRoot.join(','),
            // TODO: uncomment when bi is ready
            // fileFormat: getFileExtension(item),
          }),
        ),

      trackAdobeOpenError: () =>
        bi.logger().report(
          adobeErrorToast({
            errorReason: 'opening_error',
            source: 'adobe',
          }),
        ),

      trackAdobeSavingError: () =>
        bi.logger().report(
          adobeErrorToast({
            errorReason: 'saving_error',
            source: 'adobe',
          }),
        ),
    }),
    [publicMediaRoot, fileType],
  );
};
